export default __webpack_public_path__ + "beta-maps-guides-migrate-approximate-location-960-320af3ec84147b5a8b83a4a2ac996a9c.png";